module.exports = __webpack_public_path__ + "static/media/homePlate2Icon4.0107d033.png";